import { createTheme } from '@mui/material'
import { typography } from './typography'

// @ts-ignore
import NeueMontrealMedium from '../assets/fonts/NeueMontreal-Medium.woff'
import {SelectIcon} from "../assets/svg/selectIcon";

export const theme = createTheme({
  spacing: 6,
  palette: {
    customColors: {
      'black-100': '#000000',

      'white-100': '#ffffff',

      'grey-100': '#9B9B9B',
      'grey-200': '#AFAFAF',
      'grey-300': '#F5F6FA',
      'grey-400': '#E1E4F3',
      'grey-500': '#A4AABF',
      'grey-600': '#E8E9EE',
      'grey-700': '#62709F',

      'blue-100': '#1131F5',
      'blue-200': '#1131F580',
      'blue-400': '#DDEDF2',

      'red-100': '#DF321C',
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(221, 237, 242, 0.70)',
            backdropFilter: 'blur(10px)',
          },
        },
      },
      defaultProps: {
        PaperProps: {
          sx: {
            width: '100%',
            maxWidth: '672px',
            height: '100%',
            padding: '40px',
            borderRadius: '16px',
            boxShadow: 'unset',
            position: 'absolute',
            right: 40,
            margin: 0,
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: 0
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: 0,
          alignContent: 'flex-end'
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          padding: 0
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: 0
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        body {
          margin: 0;
          padding: 0;
          font-family: PP Neue Montreal, sans-serif;
        }
        @font-face {          
          font-family: 'PP Neue Montreal';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: url(${NeueMontrealMedium}) format('woff');
        }
      `,
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'PP Neue Montreal, sans-serif',
          letterSpacing: 'normal',
          fontSize: '16px',
          fontWeight: 500,
          color: '#000000',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          width: '100%',
          margin: '20px auto',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'PP Neue Montreal, sans-serif',
          borderRadius: '8px',
          fontSize: '16px'
        }
      },
      defaultProps: {
        disableElevation: true,
      },
      variants: [
        {
          props: { variant: 'details' },
          style: {},
        },
        {
          props: { variant: 'text' },
          style: {
            width: 'max-content',
            textTransform: 'capitalize',
            position: 'relative',
            ':hover': {
              background: 'linear-gradient(94deg, #1131F5 43.57%, #63BAD0 87.34%)',
              color: 'transparent',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              textDecoration: 'none',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '9px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 'calc(100% - 12px)',
                height: '1px',
                background: 'linear-gradient(94deg, #1131F5 43.57%, #63BAD0 87.34%)',
              },
            }
          }
        },
        {
          props: { variant: 'contained' },
          style: {
            position: 'relative',
            height: '48px',
            backgroundColor: 'transparent',
            borderRadius: '16px',
            overflow: 'hidden',
            zIndex: 0,
            color: '#ffffff',
            transition: 'all 0.3s ease-in-out',

            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: '#1131F5',
              boxShadow: 'inset 0px 0px 12px 4px rgba(173, 216, 230, 0.7)',
              transition: 'all 0.3s ease-in-out',
              zIndex: -1,
              borderRadius: 'inherit',
            },

            '&:hover': {
              '&::before': {
                background: 'linear-gradient(137deg, #1131F5 0%, #63BAD0 100%)',
                boxShadow: 'inset 0px 0px 12px 4px rgba(255, 255, 255, 0.5)',
              },
            },

            '&.Mui-disabled': {
              color: '#ffffff',
              backgroundColor: '#B1B4BF',
              border: '2px solid #B1B4BF',

              '&::before': {
                background: 'transparent',
                boxShadow: 'none',
              },
            },
          },
        },
        {
          props: { variant: 'outlined' },
          style: {
            textTransform: 'capitalize',
            border: 'none',
            '&:hover': {
              border: 'none',
            }
          },
        },
      ],
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          width: '100%',
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#F4F5F6',
            borderRadius: '16px',
            marginBottom: '4px',
          },
          '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiOutlinedInput-input': {
            padding: '12.5px 0 12.5px 16px',
          },
          'input:-webkit-autofill': {
            boxShadow: '0 0 0 1000px white inset !important',
            WebkitBoxShadow: '0 0 0 1000px white inset !important',
            color: 'inherit !important',
            transition: 'background-color 5000s ease-in-out 0s',
          }
        },
      },
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            height: '48px',
          },
        },
        {
          props: { variant: 'filled' },
          style: {},
        },
      ],
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          width: '100%',
          backgroundColor: '#ffffff',
          color: '#E23131',
          paddingTop: '4px',
          whiteSpace: 'normal',
          marginTop: 0,
          marginLeft: 0,
          '&.Mui-error': {
            color: '#E23131',
            fontSize: '12px',
            fontWeight: '500',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          width: '85px',
          height: '48px',
          borderRadius: '16px',
          backgroundColor: '#ffffff',
        },
      },
      defaultProps: {
        IconComponent: SelectIcon,
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          color: '#000000',
          backgroundColor: 'transparent',
          boxShadow: 'unset',
          ul: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          },
          li: {
            width: '85px',
            height: '48px',
            borderRadius: '16px',
            backgroundColor: '#ffffff !important',
            border: '2px solid transparent',
            '&:hover': {
              border: '2px solid #E1E4F3'
            },
            '&.Mui-selected': {
              color: '#ffffff',
              backgroundColor: '#1131F5 !important',
              border: '2px solid transparent !important',
            },
          }
        },
      },
    },
  },
  typography: () => ({
    fontFamily: 'PP Neue Montreal',
    ...typography,
  }),
})
